export default __webpack_public_path__ + "static/thumbnail_barcelona-69c5ea26f712eaecab7781b2c8707b69.jpg";